module.exports = __webpack_public_path__ + "static/media/Team-4.dd0c9385.jpg";